import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const workOrderKF: AppRouteModule = {
  path: '/workOrder/worderOrderCategory',
  name: 'workOrderKF',
  component: LAYOUT,
  // redirect: 'question',
  meta: {
    orderNo: -60,
    icon: 'ant-design:solution-outlined',
    title: '工单管理',
  },
  children: [
    {
      path: 'workOrderCategory',
      name: 'WorkOrderCategory',
      component: () => import('/@/views/workOrder/WorkOrderCategory.vue'),
      meta: {
        // affix: true,
        title: '工单分类',
        icon:'ant-design:sliders-outlined'
      },
    },
    {
      path: 'workOrderDispose',
      name: 'WorkOrderDispose',
      component: () => import('/@/views/workOrder/WorkOrderDispose.vue'),
      meta: {
        // affix: true,
        title: '工单处理',
        icon:'ant-design:reconciliation-outlined'
      },
    },
    {
      path: 'workOrderDisposeModal/:id',
      name: 'WorkOrderDisposeModal',
      component: () => import('/@/views/workOrder/WorkOrderDisposeModal.vue'),
      meta: {
        // affix: true,
        title: '工单处理详情',
        hideMenu: true,
        icon:'ant-design:sliders-outlined'
      },
    },
  ],
};

export default workOrderKF;
